import { createFileRoute } from "@tanstack/react-router";

import { HStack, Spacer } from "@/components/Layout";

import InnerNavigation from "./-components/InnerNavigation";
import { NetworkForm } from "./-components/NetworkForm";
import { ProgressCard } from "./-components/ProgressCard";
import { AddNetworkFormStore } from "./-store/add-network-form-store";

export const Route = createFileRoute("/_staff/networks/add/")({
  component: NetworksAddPage,
});

export default function NetworksAddPage() {
  const store = AddNetworkFormStore.createStore();

  return (
    <AddNetworkFormStore.Provider value={store}>
      <HStack className="w-full p-6">
        <InnerNavigation />
        <Spacer variant="m" />
        <NetworkForm className="grow min-w-[340px]" />
        <Spacer variant="m" />
        <ProgressCard />
      </HStack>
    </AddNetworkFormStore.Provider>
  );
}
